import * as React from "react";
import { singleton } from "logic/singleton";
const InputSetupWizardContext = React.createContext(void 0);
export default singleton("contexts.InputSetupWizardContext", () => InputSetupWizardContext);
